<form [formGroup]="uploadDoc">
  <div class="document-upload-main-container text">
    <div class="upload-container">
      <div class="document-select-label">
        {{ 'Document_Upload_Text_1' | t }}
      </div>
      <div class="document-select-combo">
        <select class="form-control select" required formControlName="DocumentTypeCombo">
          <option *ngFor="let item of this.documentSelectComboList" [value]="item.id" [disabled]="item.disabled">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="document-info-text">
        {{ 'Document_Upload_Text_2' | t }}
      </div>
      <div class="document-select-label-2">
        {{ 'Document_Upload_Document' | t }}
      </div>
      <div class="select-file">
        <input #file type="file" id="avatar" name="avatar" multiple (change)="upload(file.files)" />
      </div>

      <div class="document-upload-btn" *ngIf="uploadDoc.valid && file.files[0]; else noValid">
        <div (click)="sendCloudFiles()" class="btn upload-btn colored red valid">
          <div class="btn-text">{{ 'upload' | t }}</div>
        </div>
      </div>
      <ng-template #noValid>
        <div class="document-upload-btn">
          <div style="opacity: 0.45" class="btn upload-btn colored red">
            <div class="whiteText">{{ 'upload' | t }}</div>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="document-lists-container text">
      <div class="document-list-header">
        <div class="document-list-item">
          {{ 'Document_type' | t }}
        </div>
        <div class="document-list-item">
          {{ 'Date_Time' | t }}
        </div>
        <div class="document-list-item">{{ 'Statu' | t }}</div>
      </div>
      <div class="one-document-item" *ngFor="let status of fileCaseControl | sortBy : true : 'CreateDate'">
        <div class="document-type">{{ status.DocumentType | t }}</div>
        <div class="document-date">
          {{ status.CreateDate | dateFormat : 'dd.MM.yyyy' }}
        </div>
        <div
          class="document-status"
          [ngClass]="{
            'Upload-File-Status-Pending': status.DocumentStateId == 1,
            'Upload-File-Status-Approve': status.DocumentStateId == 2
          }">
          {{ status.DocumentState }}
        </div>
      </div>
    </div>
  </div>
</form>
